import { useEffect, useRef } from "react";

/* Adds the `in` class to a `.reveal` element once it scrolls into view.
   Children with [data-stagger] get an incremental transition-delay. */
export default function useReveal() {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const targets = node.matches(".reveal")
      ? [node, ...node.querySelectorAll(".reveal")]
      : [...node.querySelectorAll(".reveal")];

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );

    targets.forEach((t, i) => {
      const stagger = t.getAttribute("data-stagger");
      if (stagger !== null) {
        t.style.transitionDelay = `${i * (Number(stagger) || 90)}ms`;
      }
      io.observe(t);
    });

    return () => io.disconnect();
  }, []);

  return ref;
}
